import { Box, Container, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { retrieveTopUsers } from "./selector";
import { serverApi } from "../../../lib/config";
import { Member } from "../../../lib/types/member";

const topUsersRetriever = createSelector(retrieveTopUsers, (topUsers) => ({
  topUsers,
}));

export default function ActiveUsers() {
  const { topUsers } = useSelector(topUsersRetriever);
  return (
    <div className="active-users-frame">
      <Container>
        <Stack className="main">
          <Box className="category-title">Active Users</Box>
          <Stack className="cards-frame">
            {topUsers.length !== 0 ? (
              topUsers.slice(0, 4).map((member: Member) => {
                const imagePath = member.memberImage
                  ? `${serverApi}/${member.memberImage}`
                  : "/icons/default-user.svg";
                return (
                  <Box key={member._id} className="active-user-card">
                    <Box
                      className="active-user-photo"
                      sx={{ backgroundImage: `url(${imagePath})` }}
                    />
                    <span className="active-user-accent" />
                    <Box className="active-user-info">
                      <strong className="active-user-name">{member.memberNick}</strong>
                      <span className="active-user-status">Active Member</span>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Box className="no-data">No Active Users</Box>
            )}
          </Stack>
        </Stack>
      </Container>
    </div>
  );
}
